import React from "react";

export default function AboutSection() {
  return (
    <div className="mx-auto max-w-[900px] px-4 py-10 text-white md:py-14">
      {/* Intro */}
      <div className="space-y-5 text-[15px] leading-relaxed text-white/70 md:text-[16px]">
        <p>
          <span className="font-semibold text-white">
            On The Strip Ticketing
          </span>{" "}
          is your premier destination for tickets to the best shows in Las
          Vegas. We’re a division of SPR Promotions, bringing you closer to the
          heart of Las Vegas entertainment. Whether you’re looking for
          world-class concerts, breathtaking performances, or exclusive events,
          On The Strip Ticketing is your go-to source for securing tickets to
          the hottest shows the city has to offer.
        </p>
        <p>
          Our mission is simple: to make your Las Vegas experience unforgettable
          by providing you with easy access to the best events on the Strip.
          With a wide range of shows to choose from, including concerts,
          comedy, magic, and more, we offer a seamless and hassle-free way to
          purchase tickets for events that are guaranteed to leave you amazed.
        </p>
      </div>

      {/* Why Choose Us */}
      <div className="mt-10">
        <h3 className="mb-4 text-[18px] font-semibold text-white md:text-[20px]">
          Why Choose On The Strip Ticketing?
        </h3>
        <ul className="space-y-3 text-[15px] leading-relaxed text-white/70 md:text-[16px]">
          <li>
            <span className="font-semibold text-white">Exclusive Access:</span>{" "}
            We partner directly with top venues, promoters, and event organizers
            to offer exclusive access to tickets for the most sought-after Las
            Vegas shows.
          </li>
          <li>
            <span className="font-semibold text-white">Hassle-Free Booking:</span>{" "}
            Our user-friendly platform allows you to easily browse upcoming
            shows, select your seats, and complete your purchase without any
            hidden fees or surprises.
          </li>
          <li>
            <span className="font-semibold text-white">
              Trusted by Locals and Tourists Alike:
            </span>{" "}
            Whether you’re a local or a first-time visitor, On The Strip
            Ticketing is trusted by thousands to deliver the best entertainment
            experiences in Las Vegas.
          </li>
        </ul>
      </div>
    </div>
  );
}
